// ansaettelsesDato: string
// navn: string
// arbejdssted: {
// 		nr: number
// 		navn: string
// }
// stilling: {
// 		nr: string
// 		navn: string
// }

// nyansat: {
// 	foedselsDato: '1997-05-02',
// 	alder: 28,
// 	kontaktoplysninger: {
// 			mobilNrList: ['12345678', '23456789'],
// 			emailList: ['DummyNavn2_1@xx.dk_yy', 'DummyNavn2_2@xx.dk_yy'],
// 	},
// 	foaMedlemVisningstekst: 'Ikke fundet',
// 	arbejdsgiverEmail: 'enArbejdsgiver@vzy.åå',
// 	ansaettelsesDato: '2025-05-02',
// 	navn: 'DummyNavn2',
// 	arbejdssted: {
// 			nr: 72742,
// 			navn: 'Team Ulfborg Udegruppen',
// 	},
// 	stilling: {
// 			nr: '312',
// 			navn: 'Social- og sundhedsassistent',
// 	},
// },

export interface NewlyHiredApiData {
    foedselsDato: string
    alder: number
    kontaktoplysninger: {
        mobilNrList: string[]
        emailList: string[]
    }
    foaMedlemVisningstekst: string
    arbejdsgiverEmail: string
    ansaettelsesDato: string
    navn: string
    arbejdssted: INewlyHiredWorkplaceData
    stilling: INewlyHiredPositionData
}

export interface INewlyHiredWorkplaceData {
    nr: number
    navn: string
}

export interface INewlyHiredPositionData {
    nr: string
    navn: string
}

export class NewlyHiredWorkplace {
    nr = 0

    navn = ''

    static build(data: INewlyHiredWorkplaceData): NewlyHiredWorkplace {
        const newlyHiredWorkplace = new NewlyHiredWorkplace()

        newlyHiredWorkplace.nr = data.nr
        newlyHiredWorkplace.navn = data.navn

        return newlyHiredWorkplace
    }
}

export class NewlyHiredPosition {
    nr = ''

    navn = ''

    static build(data: INewlyHiredPositionData): NewlyHiredPosition {
        const newlyHiredPosition = new NewlyHiredPosition()

        newlyHiredPosition.nr = data.nr
        newlyHiredPosition.navn = data.navn

        return newlyHiredPosition
    }
}

export class NewlyHired {
    dateOfBirth = ''

    age = 0

    contactInfo = {
        mobileNumbers: [] as string[],
        emails: [] as string[],
    }

    foaMemberDisplayText = ''

    employerEmail = ''

    dateOfEmployment = ''

    name = ''

    workplace: NewlyHiredWorkplace | undefined

    position: NewlyHiredPosition | undefined

    static build(data: NewlyHiredApiData): NewlyHired {
        const newlyHired = new NewlyHired()

        newlyHired.dateOfBirth = data.foedselsDato
        newlyHired.age = data.alder
        newlyHired.contactInfo.mobileNumbers =
            data.kontaktoplysninger?.mobilNrList ?? []
        newlyHired.contactInfo.emails = data.kontaktoplysninger?.emailList ?? []
        newlyHired.foaMemberDisplayText = data.foaMedlemVisningstekst
        newlyHired.employerEmail = data.arbejdsgiverEmail
        newlyHired.dateOfEmployment = data.ansaettelsesDato
        newlyHired.name = data.navn
        newlyHired.workplace = data.arbejdssted
            ? NewlyHiredWorkplace.build(data.arbejdssted)
            : undefined
        newlyHired.position = data.stilling
            ? NewlyHiredPosition.build(data.stilling)
            : undefined

        return newlyHired
    }
}
